import { render, staticRenderFns } from "./GreenBorderBox.vue?vue&type=template&id=041539b3&scoped=true"
import script from "./GreenBorderBox.vue?vue&type=script&lang=js"
export * from "./GreenBorderBox.vue?vue&type=script&lang=js"
import style0 from "./GreenBorderBox.vue?vue&type=style&index=0&id=041539b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041539b3",
  null
  
)

export default component.exports